import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=13054d24&scoped=true&"
import script from "./ProductHeader.vue?vue&type=script&lang=js&"
export * from "./ProductHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13054d24",
  null
  
)

export default component.exports